import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper" }
const _hoisted_2 = { class: "gfu-grid gfu-grid--gutter" }
const _hoisted_3 = { class: "gfu-grid__cell gfu-1of1 gfu-4of6--l" }
const _hoisted_4 = { class: "gfu-box _mt-6 _mb-6" }
const _hoisted_5 = { "data-qa": "select-order-form" }
const _hoisted_6 = { class: "_mb-6" }
const _hoisted_7 = {
  key: 1,
  class: "_ml-6"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "gfu-field has-error _mt-0" }
const _hoisted_10 = { class: "gfu-grid" }
const _hoisted_11 = { class: "gfu-grid__cell gfu-1of2 gfu-1of2--m gfu-1of3--xl _pr-1" }
const _hoisted_12 = { class: "gfu-grid__cell gfu-1of2 gfu-1of2--m gfu-1of3--xl _tar _pl-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("h1", {
          class: "gfu-heading gfu-heading--main _mt-3",
          "data-qa": "page-title"
        }, "New order", -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("p", null, " It appears you already have another pledge in this project. What do you want to do? ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("fieldset", _hoisted_6, [
              ($props.allowPlaceNewOrder)
                ? (_openBlock(), _createBlock(_component_checkbox_field, {
                    key: 0,
                    modelValue: $data.model.createNewOrder,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.createNewOrder) = $event)),
                    condensed: true,
                    type: "radio",
                    "display-name": "Make a new pledge.",
                    "checked-value": true,
                    "data-qa": "select-order-form:NewOrder"
                  }, null, 8 /* PROPS */, ["modelValue"]))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_checkbox_field, {
                modelValue: $data.model.createNewOrder,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.model.createNewOrder) = $event)),
                condensed: true,
                type: "radio",
                "display-name": "Add items to one of your previous pledges.",
                "checked-value": false,
                "data-qa": "select-order-form:PreviousOrder"
              }, null, 8 /* PROPS */, ["modelValue"]),
              (!$data.model.createNewOrder)
                ? (_openBlock(), _createElementBlock("fieldset", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.model.previousOrders, (order) => {
                      return (_openBlock(), _createBlock(_component_checkbox_field, {
                        key: `previous-order-${order.orderID}`,
                        modelValue: $data.model.selectedPreviousOrderCode,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.model.selectedPreviousOrderCode) = $event)),
                        condensed: true,
                        type: "radio",
                        "checked-value": order.orderCode,
                        "data-qa": 'select-order-form-order:'+ order.orderCode
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.itemsCount) + " " + _toDisplayString($options.pluralize(order.itemsCount, 'item')) + " for " + _toDisplayString(_ctx.$format(order.totalDiscountedValueConverted, 'C2', order.currencySymbol)) + " placed on " + _toDisplayString(_ctx.$format(order.createDate)), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "checked-value", "data-qa"]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (!_ctx.isProcessing && !$data.model.previousOrders.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, "You don't have any paid orders that could be modified"))
                      : _createCommentVNode("v-if", true),
                    _withDirectives(_createElementVNode("div", _hoisted_9, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("p", { class: "gfu-field__error" }, "Please choose one of the options.", -1 /* CACHED */)
                    ]))], 512 /* NEED_PATCH */), [
                      [_vShow, _ctx.errors.has('model.selectedPreviousOrderCode')]
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  class: "gfu-btn gfu-btn--light gfu-btn--block",
                  onClick: _cache[3] || (_cache[3] = (...args) => ($options.cancel && $options.cancel(...args))),
                  "data-qa": "select-order-form-btn:Cancel"
                }, _toDisplayString(_ctx.Resources.Checkout.BackToCartButton), 1 /* TEXT */)
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "gfu-grid__cell gfu-1of2 gfu-1of2--m gfu-1of3--xl _pa-3 _screen--none _screen--xl" }, null, -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "button",
                  class: "gfu-btn gfu-btn--accent gfu-btn--block",
                  onClick: _cache[4] || (_cache[4] = (...args) => ($options.submit && $options.submit(...args))),
                  "data-qa": "select-order-form-btn:Continue"
                }, _toDisplayString(_ctx.Resources.Common.ModalContinueButton), 1 /* TEXT */)
              ])
            ]),
            _createVNode(_component_progress_overlay, {
              visible: _ctx.isProcessing,
              sticky: true
            }, null, 8 /* PROPS */, ["visible"])
          ])
        ])
      ])
    ])
  ]))
}